/* debug class for console log management */

class DebugLogging {
	constructor() {
		this.enabled = false;
		this.logPrefix = "";
	}

	enable() {
		this.enabled = true;
	}

	disable() {
		this.enabled = false;
	}

	setLogPrefix(prefix) {
		this.logPrefix = prefix;
	}

	log(str, data, list) {
		if (!this.enabled) {
			return false;
		}
		str = (this.logPrefix ? this.logPrefix + " - " : "") + str;
		if (list) {
			window.console.log(str, data);
		} else {
			window.console.log(str);
		}
	}
}

const Debug = new DebugLogging();
export default Debug;
